import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import HistoricalTrendOverlay from './pages/historical-trend-overlay';
import MainVisualizationDashboard from './pages/main-visualization-dashboard';
import MobileResponsiveView from './pages/mobile-responsive-view';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<MainVisualizationDashboard />} />
        <Route path="/historical-trend-overlay" element={<HistoricalTrendOverlay />} />
        <Route path="/main-visualization-dashboard" element={<MainVisualizationDashboard />} />
        <Route path="/mobile-responsive-view" element={<MobileResponsiveView />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
